import * as React from "react"
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function validatedColumn() {
	return [{
		name: 'validated', label: 'Validated',
		options: {
			display: 'excluded',
			filterType: "checkbox",
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'validated', label: 'Validated',
		options: {
			filter: false,
			customBodyRowRender: (value) => {
				const icon = value ? "square-check" : "square-xmark"
				const color = value ? "success.lighter" : "error.lighter"

				return <Box sx={{ textAlign: 'center', fontSize: 21 }}>
					<IconSeeker icon={icon} sx={{ color: color }} />
				</Box>
			}
		}
	}]
}